export default "__VITE_ASSET__Br2SiIg8__"